<template>
  <pn-select
    name="country"
    searchable
    required
    :value="value"
    :placeholder="$t('W2P_SELECT_COUNTRY')"
    :searchPlaceholder="$t('W2P_SEARCH_COUNTRY')"
    @selectchange="update"
    @selectsearch="searchCountry"
  >
    <pn-option
      v-for="(country, i) in filteredCountry"
      v-show="country.show"
      :key="i"
      :value="country.code"
      >{{ country.name }}
    </pn-option>
  </pn-select>
</template>

<script>
import countries from '@/components/common/country/countries.json'
import { mapState } from 'vuex'

export default {
  name: 'CountrySelection',
  props: {
    searchable: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: 'SE'
    }
  },
  model: {
    event: `update`
  },
  data() {
    return {
      country: '',
      filter: ''
    }
  },
  computed: {
    ...mapState(['lang']),
    filteredCountry() {
      const regex = new RegExp(this.filter.toLowerCase(), 'i')
      return this.countries.map(country => {
        const searchString =
          country.name.toLowerCase() + ' ' + country.code.toLowerCase()

        country.show = regex.test(searchString)
        return country
      })
    },
    countries() {
      return countries[this.lang] || countries['en']
    }
  },
  methods: {
    update({ detail }) {
      if (detail) {
        this.$emit('update', detail)
      }
    },
    searchCountry({ detail }) {
      this.filter = detail
    }
  }
}
</script>

<style lang="scss" scoped>
pn-select {
  width: 100%;
  margin: 1em 0 0 0;
}
</style>
